import {create} from "apisauce";
import {getCookie} from "../../utils/cookies";


const apiClient = create({
    baseURL: process.env.REACT_APP_PORTAL_URL,
});

apiClient.addAsyncRequestTransform(async (request) => {

    const authToken = getCookie("ycon_auth0_token")
    if (!authToken) return;
    request.headers["authorization"] = "Bearer " + authToken;
});


export default apiClient;